import { CacheRespuestas } from "./CacheRespuestas";
import { TipoCacheRespuestaEnum } from "@shared/enums";
import { Respuesta, RespuestaExtra } from "../../../../../layout/investigaciones/ver-respuestas/Respuesta";
import { Injectable } from "@angular/core";
import { ProcesoDatos } from "@shared/clases";
import { ItemPreguntaDTO } from "@DTOS";

@Injectable({
    providedIn: "root"
})
export class CacheRespuestasImpl implements CacheRespuestas {
    private cacheRespuestas = new Map<TipoCacheRespuestaEnum, Respuesta[]>();
    private cacheRespuestasProcesadas = new Map<number, RespuestaExtra>();

    /**
     * Devuelve si existen respuestas guardadas para este tipo de respuesta
     *
     * @param tipoCacheRespuesta Tipo de respuesta a verificar si existe
     */
    public existenRespuestas(tipoCacheRespuesta: TipoCacheRespuestaEnum): boolean {
        return this.cacheRespuestas.has(tipoCacheRespuesta);
    }

    /**
     * Obtiene las respuestas guardadas, debe verificar antes si existen respuestas guardadas
     *
     * @param tipoCacheRespuesta Tipo de cache de respuesta a obtener las respuestas
     */
    public obtenerRespuestas(tipoCacheRespuesta: TipoCacheRespuestaEnum): Respuesta[] {
        return this.cacheRespuestas.get(tipoCacheRespuesta)!;
    }

    /**
     * Limpia la cache de respuestas
     */
    public limpiar() {
        this.cacheRespuestas.clear();
    }

    /**
     * Obtener respuesta procesada por item id, debe verificar que existan las respuestas
     *
     * @param itemId Item id a obtener
     */
    public obtenerRespuestaProcesada(itemId: number): RespuestaExtra {
        return this.cacheRespuestasProcesadas.get(itemId)!;
    }

    /**
     * Devuelve si existen respuestas asociadas al item id
     */
    public existenRespuestaProcesada(itemId: number): boolean {
        return this.cacheRespuestasProcesadas.has(itemId);
    }

    public guardarDesdeProcesoDatos(procesoDatos: ProcesoDatos) {
        this.cacheRespuestas.set(TipoCacheRespuestaEnum.RANGOS_EDAD, procesoDatos.rangosEdad);
        this.cacheRespuestas.set(TipoCacheRespuestaEnum.GENEROS, procesoDatos.generos);
        this.cacheRespuestas.set(TipoCacheRespuestaEnum.PAISES, procesoDatos.paises);
        this.cacheRespuestas.set(TipoCacheRespuestaEnum.REGIONES, procesoDatos.regiones);
        this.cacheRespuestas.set(TipoCacheRespuestaEnum.CIUDADES, procesoDatos.ciudades);
        this.cacheRespuestasProcesadas = new Map(procesoDatos.respuestasProcesadas);
    }

    public obtenerUsuariosPorItem(item: ItemPreguntaDTO): Set<number> {
        return this.cacheRespuestasProcesadas.get(item.id)?.usuarios ?? new Set<number>();
    }
}
